import { LinkField, RichTextField, Field } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type C52HeroStatisticsProps = RenderingProps<
  C52HeroStatisticsFields,
  C52HeroStatisticsParams
>;

export type C52HeroStatisticsFields = {
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  SupportCopyBottom?: RichTextField;
  Cta?: LinkField;
};

export type C52HeroStatisticsParams = {
  BackgroundColor?: string;
  ContentAlignments?: string;
  CtaAlignment?: string;
  HeadlineTag?: string;
  NumberOfColumns?: string;
  NumberOfColumnsMobile?: string;
  ShowColumnDividers?: string;
} & DynamicPlaceholderParams &
  AnchorTargetParams &
  TranslationOptionsParams;
